import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CalendarHeartIcon } from 'lucide-react';
import { goToCart } from './constants';
// Shows a sticky floating CTA once the user scrolls past the hero's first CTA.
export function FloatingCta({
  triggerRef
}: {
  triggerRef: React.RefObject<HTMLDivElement>;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = triggerRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the trigger (bottom of hero CTA) has scrolled out of view upward.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [triggerRef]);
  return <AnimatePresence data-id="element-92">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 26
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-navy/10 bg-cream/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-md" data-id="element-93">
          <div className="mx-auto max-w-md" data-id="element-94">
            <button type="button" onClick={goToCart} className="animate-pulse-ring flex w-full items-center justify-center gap-2 rounded-2xl bg-magenta px-5 py-4 text-sm font-extrabold uppercase tracking-tight text-white shadow-[0_8px_0_0_#c00e69] transition-transform active:translate-y-1 active:shadow-[0_3px_0_0_#c00e69] sm:text-base" data-id="element-95">
              <CalendarHeartIcon className="h-5 w-5 shrink-0" data-id="element-96" />
              <span className="flex items-baseline gap-2" data-id="element-97">
                Quiero mis 28 minutos
                <span className="text-white/80 line-through" data-id="element-98">$97</span>
                <span data-id="element-99">$12.99</span>
              </span>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}